import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } }
};

export const VideoSection = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) videoRef.current.pause();
      else videoRef.current.play();
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  return (
    <section id="video" className="py-20 bg-[#29282B] hex-pattern-dark" data-testid="video-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={fadeUp} className="text-center mb-12">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4">Découvrez EduPlan en action</h2>
          <p className="text-white/70 text-lg">Une minute pour comprendre comment transformer vos plans de classe</p>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={scaleIn} className="relative video-container">
          <video ref={videoRef} autoPlay muted loop playsInline className="w-full aspect-video object-cover" data-testid="video-player">
            <source src="/hero-video.mp4" type="video/mp4" />
          </video>
          
          <div className="video-overlay" />
          
          <div className="absolute bottom-4 right-4 flex gap-2">
            <button onClick={togglePlay} className="p-3 bg-white/20 backdrop-blur-md rounded-full hover:bg-white/30 transition-all" data-testid="video-play-btn">
              {isPlaying ? <Pause className="text-white" size={20} /> : <Play className="text-white" size={20} />}
            </button>
            <button onClick={toggleMute} className={`p-3 backdrop-blur-md rounded-full hover:bg-white/30 transition-all ${isMuted ? 'bg-white/20' : 'bg-[#E7A541]'}`} data-testid="video-mute-btn">
              {isMuted ? <VolumeX className="text-white" size={20} /> : <Volume2 className="text-white" size={20} />}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VideoSection;
